import { ApiOnboardingSurveyRequestBody } from 'BackendApi'

export const validateOnboardingStep1 = (
  values: ApiOnboardingSurveyRequestBody
) => {
  const step1Fields = [
    'position',
    'companyName',
    'industry',
    'capacity',
    'country',
  ] as const

  return step1Fields.every((field) => {
    const value = values[field]
    return Boolean(value && value.trim() !== '')
  })
}

export const validateOnboardingStep2 = (
  values: ApiOnboardingSurveyRequestBody
) => {
  const step2Fields = [
    'sourceApp',
    'destinationApp',
    'budget',
    'goal',
  ] as const

  return step2Fields.every((field) => {
    const value = values[field]
    return Boolean(value && value.trim() !== '')
  })
}
